import { Spacing } from "components/designV2/constants";
import { ColorV2 } from "config/colors";
import { TypographyV2 } from "config/font";
import styled from "styled-components";

export const PayoutSectionTitle = styled.h3`
  ${TypographyV2.h4}
  color: ${ColorV2.Blue1};
  margin: 0;
`;

export const PayoutMethodGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.md}px;
`;

export const PayoutMethodButton = styled.button`
  align-items: center;
  background: ${ColorV2.Blue1};
  border: none;
  border-radius: 999px;
  color: ${ColorV2.White};
  display: grid;
  gap: ${Spacing.md}px;
  grid-template-columns: 40px minmax(0, 1fr) 24px;
  min-height: 72px;
  padding: ${Spacing.md}px;
  text-align: left;
  width: 100%;

  &:hover {
    cursor: pointer;
  }
`;

export const PayoutMethodIcon = styled.span`
  align-items: center;
  background: ${ColorV2.White};
  border-radius: 999px;
  display: inline-flex;
  height: 40px;
  justify-content: center;
  width: 40px;
`;

export const PayoutSwishIcon = styled.img`
  display: block;
  height: 32px;
  width: 32px;
`;

export const PayoutMethodLabel = styled.span`
  ${TypographyV2.b1}
  color: ${ColorV2.White};
`;

export const PayoutMethodDescription = styled.p`
  ${TypographyV2.s1}
  color: ${ColorV2.Blue4};
  margin: 0;
`;
